import { Component, OnInit, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'stg-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  @Input() title = '';
  @Input() show = true;

  @HostBinding('style.display') get display () {
    return this.show ? 'block' : 'none';
  }

  constructor() { }

  ngOnInit() {
  }

  public close() {
    this.show = false;
  }

}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/shared-components/modal/modal.component.ts